import { ContractDocument } from "..";

export default class ComplianceCheck extends ContractDocument {
  static type = "contractDocumentComplianceChecks";
}
